import React from "react";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { BADGE_TYPES, BADGE_LABELS } from "../../utils/constants";

const BADGE_VALUE_TO_LABEL = {
  [BADGE_TYPES.ADSB_VERIFIED]: BADGE_LABELS.ADSB_VERIFIED,
  [BADGE_TYPES.BMS_VERIFIED]: BADGE_LABELS.BMS_VERIFIED,
};

const BadgesFilterSelect = ({
  selectedBadges = [],
  onChange,
  selectClassName = "",
}) => {
  const handleBadgesChange = (event) => {
    const {
      target: { value },
    } = event;
    const badges = typeof value === "string" ? value.split(",") : value;
    if (onChange) {
      onChange(badges);
    }
  };

  return (
    <Select
      multiple
      displayEmpty
      value={selectedBadges}
      onChange={handleBadgesChange}
      className={selectClassName}
      renderValue={(selected) =>
        selected.length > 0 ? (
          selected.length === Object.values(BADGE_TYPES).length
            ? BADGE_LABELS.ALL_BADGES_SELECTED
            : selected
                .map((badge) => BADGE_VALUE_TO_LABEL[badge] || badge)
                .join(", ")
        ) : (
          <span className="placeholder-text">Select</span>
        )
      }
    >
      <MenuItem value={BADGE_TYPES.ADSB_VERIFIED}>
        <Checkbox checked={selectedBadges.includes(BADGE_TYPES.ADSB_VERIFIED)} />
        <ListItemText primary={BADGE_LABELS.ADSB_VERIFIED} />
      </MenuItem>
      <MenuItem value={BADGE_TYPES.BMS_VERIFIED}>
        <Checkbox checked={selectedBadges.includes(BADGE_TYPES.BMS_VERIFIED)} />
        <ListItemText primary={BADGE_LABELS.BMS_VERIFIED} />
      </MenuItem>
    </Select>
  );
};

export default BadgesFilterSelect;


